import '../sass/project.scss';

import Alpine from 'alpinejs';
import 'htmx.org';
import 'leaflet/dist/leaflet.css';
import 'maplibre-gl/dist/maplibre-gl.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

window.Alpine = Alpine;

window.__ = window.gettext || ((text) => text);

function showToast(message, level = 'info') {
  const region = document.getElementById('toast-region');
  if (!region || !message) return;
  const toast = document.createElement('div');
  const tones = {
    success: 'text-bg-success',
    error: 'text-bg-danger',
    warning: 'text-bg-warning',
    info: 'text-bg-secondary',
  };
  toast.className = `toast show align-items-center border-0 mb-2 ${tones[level] || tones.info}`;
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  const body = document.createElement('div');
  body.className = 'd-flex';
  const text = document.createElement('div');
  text.className = 'toast-body';
  text.textContent = message;
  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'btn-close btn-close-white me-2 m-auto';
  close.setAttribute('aria-label', 'Close');
  close.addEventListener('click', () => toast.remove());
  body.append(text, close);
  toast.append(body);
  region.append(toast);
  window.setTimeout(() => toast.remove(), 6000);
}

window.showToast = showToast;

document.body.addEventListener('show-toast', (event) => {
  showToast(
    event.detail && event.detail.message,
    event.detail && event.detail.level,
  );
});

document.addEventListener('htmx:configRequest', (event) => {
  const csrfMeta = document.querySelector('meta[name="csrf-token"]');
  if (csrfMeta && !event.detail.headers['X-CSRFToken']) {
    event.detail.headers['X-CSRFToken'] = csrfMeta.content;
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-flash]').forEach((el) => {
    showToast(el.dataset.message, el.dataset.flash);
  });
  if (
    document.querySelector('[data-leaflet]') ||
    document.getElementById('infra-map')
  ) {
    import(/* webpackChunkName: "maps" */ './maps').then((m) => {
      m.initLeafletMaps();
      m.initInfraMap();
    });
  }
  if (document.querySelector('canvas[data-chart]')) {
    import(/* webpackChunkName: "charts" */ './charts').then((m) =>
      m.initCharts(),
    );
  }
});

Alpine.start();
